export const TAB = 9;
export const ESCAPE = 27;
export const ARROWLEFT = 37;
export const ARROWUP = 38;
export const ARROWRIGHT = 39;
export const ARROWDOWN = 40;
export const SPACEBAR = 32;
export const ENTER = 13;

export default {
  ARROW_DOWN: ARROWDOWN,
  ARROW_LEFT: ARROWLEFT,
  ARROW_RIGHT: ARROWRIGHT,
  ARROW_UP: ARROWUP,
  ENTER,
  ESCAPE,
  SPACE_BAR: SPACEBAR,
  TAB
};



// WEBPACK FOOTER //
// ./src/utils/keyCharCodes.js